import React, { PropsWithChildren, Suspense } from "react";
import Loading from "../Loading";

export default function SuspenseLoader({
  children,
}: PropsWithChildren<Record<string, unknown>>) {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
}
